// src/composables/useInView.js
import { ref, onMounted, onUnmounted } from 'vue'

export function useInView(options = {}) {
  const isVisible = ref(false)
  const target = ref(null)
  let observer

  const observe = () => {
    if (!target.value) return

    observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          isVisible.value = true
          observer.unobserve(target.value)
        }
      },
      {
        threshold: options.threshold || 0.1,
        rootMargin: options.rootMargin || '0px 0px -100px 0px'
      }
    )
    observer.observe(target.value)
  }

  onMounted(observe)
  onUnmounted(() => observer?.disconnect())

  return { isVisible, target }
}